import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useMyProfile } from "@/hooks/useMyProfile";
import { ReadOnly, ProfilePhotoPicker, CareHomeFields, TrainerFields } from "@/components/profile/ProfileFields";

const ROLE_LABEL = { manager: "Care Home Manager", staff: "Care Staff", trainer: "Trainer", admin: "Platform Admin" };

export function MyProfileForm({ onSaved }) {
  const { p, form, set, saving, uploading, fileRef, save, upload, removePhoto } = useMyProfile(onSaved);
  if (!p) return null;
  const role = p.role;

  return (
    <form onSubmit={save} className="space-y-6" data-testid="my-profile-form">
      <ProfilePhotoPicker p={p} role={role} uploading={uploading} fileRef={fileRef} onUpload={upload} onRemove={removePhoto} />
      <div className="grid md:grid-cols-2 gap-4">
        <div><Label>Full name</Label><Input data-testid="my-profile-name" required value={form.name} onChange={set("name")} /></div>
        <div><Label>Mobile number</Label><Input data-testid="my-profile-mobile" type="tel" value={form.mobile} onChange={set("mobile")} placeholder="07…" /></div>
        <ReadOnly label="Email" value={p.email} testId="my-profile-email" />
        <ReadOnly label="Role" value={ROLE_LABEL[role] || role} testId="my-profile-role" />
        {(role === "manager" || role === "staff") && <CareHomeFields role={role} home={p.care_home} form={form} set={set} />}
        {role === "trainer" && <TrainerFields p={p} form={form} set={set} />}
      </div>
      <Button type="submit" data-testid="my-profile-save-btn" disabled={saving} className="rounded-full bg-brand hover:bg-brand-hover text-white h-10 px-6">{saving ? "Saving…" : "Save details"}</Button>
    </form>
  );
}
